import { Button, styled } from "@mui/joy";
import React, { ChangeEvent, useEffect, useState } from "react"
import { useSelector } from "react-redux";
import { BASE_URL, BLACK, PRIMARY } from "../../appConstants";
import axios from "axios";
import appError from "../../appError";
import toast from "react-hot-toast";
import { useParams } from "react-router-dom";

const Masters: React.FC = () => {
    const {brand_id, platform_id} = useParams();
    // const platform_id = '2b2c5687-6887-4f4c-9509-4abd7341b81e';     // Currently HardCoded for Amazon 
    // const { platform_id } = useSelector((state: any) => state.appData);
    const [displayText, setDisplayText] = useState<string>("");
    const [loading, setLoading] = useState<string>("");    

    console.log('--->', brand_id, platform_id);
    useEffect(() => {
        const brand = JSON.parse(localStorage.getItem("brand") as string);
        const platform = JSON.parse(localStorage.getItem("platform") as string);
        // const platform = 'Amazon';     // Currently HardCoded for Amazon 


        if (brand && platform) {

            setDisplayText(`${brand.brand_name}, ${platform?.platform}`);


        } else {
            setDisplayText("Select Dashboard")
        }
    }, [brand_id, platform_id])


    const downloadClickHandler = async (type: string) => {
        try {
            setLoading(type);
            const token = localStorage.getItem("token");
            const res = await axios.post(`${BASE_URL}brand/queueMaster?brand_id=${brand_id}&platform_id=${platform_id}&type=${type}`, {},
                {
                    headers: {
                        "Authorization": `Bearer ${token}`
                    }
                }
            );
            const { message } = res?.data?.data;
            toast.success(message, { duration: 5000 });

        } catch (error) {
            appError(error);
        } finally {
            setLoading("");
        }
    }

    const onFileChange = async (event: ChangeEvent<HTMLInputElement>, type: string) => {

        if (!(event.target.files && event.target.files.length > 0)) {
            return appError("File not selected.");
        }

        try {
            setLoading(type)
            let file = event.target.files[0];
console.log(file);


            const token = localStorage.getItem("token");




            const formData = new FormData();
            formData.append('myFile', file);

            console.log(formData);

            const res = await axios.post(`${BASE_URL}brand/master/fileUpload?brand_id=${brand_id}&platform_id=${platform_id}&type=${type}`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    "Authorization": `Bearer ${token}`
                }
            });
 
            const { message, data: { filename, originalname, created_time_stamp } } = res?.data;
            console.log(message, filename, originalname, created_time_stamp);
            toast.success(message);
        } catch (err: any) {
            console.log(err);
            appError(err?.response?.data?.data?.message);
        } finally {
            setLoading("");
        }

    };

    const VisuallyHiddenInput = styled('input')`
    clip: rect(0 0 0 0);
    clip-path: inset(50%);
    height: 1px;
    overflow: hidden;
    position: absolute;
    bottom: 0;
    left: 0;
    white-space: nowrap;
    width: 1px;
    `;

    return (
        <div >
            {
                displayText === "Select Dashboard" ? (
                    <>
                        <div style={{ height: 60, display: "flex", alignItems: "center" }} >
                            <span style={{ fontSize: 24, margin: 20 }} >
                                Please Select Dashboard.
                            </span>
                        </div>
                    </>
                ) : (
                    <>
                        <div style={{ height: 60, display: "flex", alignItems: "center" }} >
                            <span style={{ fontSize: 24, margin: 20 }} >
                                {displayText}
                            </span>
                        </div>

                        <div style={{ display: "flex", justifyContent: "start", alignItems: "center" }} >
                            <div style={{
                                fontSize: 24,
                                margin: 20
                            }} >
                                Master
                            </div>
                            <Button
                                loading={loading === "COMPLETE_MASTER"}
                                onClick={() => downloadClickHandler("COMPLETE_MASTER")}

                                endDecorator={
                                    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                                        <path d="M17.8172 10.4425L12.1922 16.0675C12.0749 16.1848 11.9159 16.2507 11.75 16.2507C11.5841 16.2507 11.4251 16.1848 11.3078 16.0675C11.1905 15.9503 11.1247 15.7912 11.1247 15.6253C11.1247 15.4595 11.1905 15.3004 11.3078 15.1832L15.8664 10.6253H3.625C3.45924 10.6253 3.30027 10.5595 3.18306 10.4423C3.06585 10.3251 3 10.1661 3 10.0003C3 9.83459 3.06585 9.67562 3.18306 9.55841C3.30027 9.4412 3.45924 9.37535 3.625 9.37535H15.8664L11.3078 4.81753C11.1905 4.70026 11.1247 4.5412 11.1247 4.37535C11.1247 4.2095 11.1905 4.05044 11.3078 3.93316C11.4251 3.81588 11.5841 3.75 11.75 3.75C11.9159 3.75 12.0749 3.81588 12.1922 3.93316L17.8172 9.55816C17.8753 9.61621 17.9214 9.68514 17.9529 9.76101C17.9843 9.83688 18.0005 9.91821 18.0005 10.0003C18.0005 10.0825 17.9843 10.1638 17.9529 10.2397C17.9214 10.3156 17.8753 10.3845 17.8172 10.4425Z" fill="white" />
                                    </svg>
                                }
                                sx={{
                                    height: "48px",
                                    width: "200px",
                                    backgroundColor: PRIMARY.P_BLue,
                                    margin: "20px"
                                }}
                            >COMPLETE_MASTER
                            </Button>
                        </div>

                        <div style={{ display: "flex", justifyContent: "start", alignItems: "center" }} >
                            <div style={{
                                fontSize: 24,
                                margin: 20
                            }} >
                                Product
                            </div>
                            <Button
                                loading={loading === "MASTER_PRODUCT"}
                                onClick={() => downloadClickHandler("MASTER_PRODUCT")}

                                endDecorator={
                                    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                                        <path d="M17.8172 10.4425L12.1922 16.0675C12.0749 16.1848 11.9159 16.2507 11.75 16.2507C11.5841 16.2507 11.4251 16.1848 11.3078 16.0675C11.1905 15.9503 11.1247 15.7912 11.1247 15.6253C11.1247 15.4595 11.1905 15.3004 11.3078 15.1832L15.8664 10.6253H3.625C3.45924 10.6253 3.30027 10.5595 3.18306 10.4423C3.06585 10.3251 3 10.1661 3 10.0003C3 9.83459 3.06585 9.67562 3.18306 9.55841C3.30027 9.4412 3.45924 9.37535 3.625 9.37535H15.8664L11.3078 4.81753C11.1905 4.70026 11.1247 4.5412 11.1247 4.37535C11.1247 4.2095 11.1905 4.05044 11.3078 3.93316C11.4251 3.81588 11.5841 3.75 11.75 3.75C11.9159 3.75 12.0749 3.81588 12.1922 3.93316L17.8172 9.55816C17.8753 9.61621 17.9214 9.68514 17.9529 9.76101C17.9843 9.83688 18.0005 9.91821 18.0005 10.0003C18.0005 10.0825 17.9843 10.1638 17.9529 10.2397C17.9214 10.3156 17.8753 10.3845 17.8172 10.4425Z" fill="white" />
                                    </svg>
                                }
                                sx={{
                                    height: "48px",
                                    width: "200px",
                                    backgroundColor: PRIMARY.P_BLue,
                                    margin: "20px"
                                }}
                            >MASTER_PRODUCT
                            </Button>
                            <Button
                                loading={loading === "UNMAPPED_PRODUCT"}
                                onClick={() => downloadClickHandler("UNMAPPED_PRODUCT")}

                                endDecorator={
                                    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                                        <path d="M17.8172 10.4425L12.1922 16.0675C12.0749 16.1848 11.9159 16.2507 11.75 16.2507C11.5841 16.2507 11.4251 16.1848 11.3078 16.0675C11.1905 15.9503 11.1247 15.7912 11.1247 15.6253C11.1247 15.4595 11.1905 15.3004 11.3078 15.1832L15.8664 10.6253H3.625C3.45924 10.6253 3.30027 10.5595 3.18306 10.4423C3.06585 10.3251 3 10.1661 3 10.0003C3 9.83459 3.06585 9.67562 3.18306 9.55841C3.30027 9.4412 3.45924 9.37535 3.625 9.37535H15.8664L11.3078 4.81753C11.1905 4.70026 11.1247 4.5412 11.1247 4.37535C11.1247 4.2095 11.1905 4.05044 11.3078 3.93316C11.4251 3.81588 11.5841 3.75 11.75 3.75C11.9159 3.75 12.0749 3.81588 12.1922 3.93316L17.8172 9.55816C17.8753 9.61621 17.9214 9.68514 17.9529 9.76101C17.9843 9.83688 18.0005 9.91821 18.0005 10.0003C18.0005 10.0825 17.9843 10.1638 17.9529 10.2397C17.9214 10.3156 17.8753 10.3845 17.8172 10.4425Z" fill="white" />
                                    </svg>
                                }
                                sx={{
                                    height: "48px",
                                    width: "200px",
                                    backgroundColor: PRIMARY.P_BLue,
                                    margin: "20px"
                                }}
                            >UNMAPPED_PRODUCT
                            </Button>
                            {/* UPLOAD COMPONENT */}
                            <div >
                                <Button
                                    loading={loading === "UPDATE_PRODUCT"}
                                    component="label"
                                    role={undefined}
                                    tabIndex={-1}
                                    variant="outlined"
                                    color="neutral"
                                    style={{
                                        height: "48px",
                                        margin: "20px",
                                        border: `1px dashed ${BLACK.B_10}`
                                    }}
                                >
                                    <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                                        <div style={{ display: "flex", alignItems: "center", fontSize: 14, fontWeight: 700, lineHeight: "20px" }} >
                                            Upload Mapped Product File Here
                                        </div>
                                    </div>
                                    <VisuallyHiddenInput
                                        onChange={(e) => onFileChange(e, "UPDATE_PRODUCT")}
                                        type="file" />
                                </Button>
                            </div>
                        </div>

                        <div style={{ display: "flex", justifyContent: "start", alignItems: "center" }} >
                            <div style={{
                                fontSize: 24,
                                margin: 20
                            }} >
                                Targeting
                            </div>
                            <Button
                                loading={loading === "MASTER_TARGETING"}
                                onClick={() => downloadClickHandler("MASTER_TARGETING")}

                                endDecorator={
                                    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                                        <path d="M17.8172 10.4425L12.1922 16.0675C12.0749 16.1848 11.9159 16.2507 11.75 16.2507C11.5841 16.2507 11.4251 16.1848 11.3078 16.0675C11.1905 15.9503 11.1247 15.7912 11.1247 15.6253C11.1247 15.4595 11.1905 15.3004 11.3078 15.1832L15.8664 10.6253H3.625C3.45924 10.6253 3.30027 10.5595 3.18306 10.4423C3.06585 10.3251 3 10.1661 3 10.0003C3 9.83459 3.06585 9.67562 3.18306 9.55841C3.30027 9.4412 3.45924 9.37535 3.625 9.37535H15.8664L11.3078 4.81753C11.1905 4.70026 11.1247 4.5412 11.1247 4.37535C11.1247 4.2095 11.1905 4.05044 11.3078 3.93316C11.4251 3.81588 11.5841 3.75 11.75 3.75C11.9159 3.75 12.0749 3.81588 12.1922 3.93316L17.8172 9.55816C17.8753 9.61621 17.9214 9.68514 17.9529 9.76101C17.9843 9.83688 18.0005 9.91821 18.0005 10.0003C18.0005 10.0825 17.9843 10.1638 17.9529 10.2397C17.9214 10.3156 17.8753 10.3845 17.8172 10.4425Z" fill="white" />
                                    </svg>
                                }
                                sx={{
                                    height: "48px",
                                    width: "200px",
                                    backgroundColor: PRIMARY.P_BLue,
                                    margin: "20px"
                                }}
                            >MASTER_TARGETING
                            </Button>
                            <Button
                                loading={loading === "UNMAPPED_TARGETING"}
                                onClick={() => downloadClickHandler("UNMAPPED_TARGETING")}

                                endDecorator={
                                    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                                        <path d="M17.8172 10.4425L12.1922 16.0675C12.0749 16.1848 11.9159 16.2507 11.75 16.2507C11.5841 16.2507 11.4251 16.1848 11.3078 16.0675C11.1905 15.9503 11.1247 15.7912 11.1247 15.6253C11.1247 15.4595 11.1905 15.3004 11.3078 15.1832L15.8664 10.6253H3.625C3.45924 10.6253 3.30027 10.5595 3.18306 10.4423C3.06585 10.3251 3 10.1661 3 10.0003C3 9.83459 3.06585 9.67562 3.18306 9.55841C3.30027 9.4412 3.45924 9.37535 3.625 9.37535H15.8664L11.3078 4.81753C11.1905 4.70026 11.1247 4.5412 11.1247 4.37535C11.1247 4.2095 11.1905 4.05044 11.3078 3.93316C11.4251 3.81588 11.5841 3.75 11.75 3.75C11.9159 3.75 12.0749 3.81588 12.1922 3.93316L17.8172 9.55816C17.8753 9.61621 17.9214 9.68514 17.9529 9.76101C17.9843 9.83688 18.0005 9.91821 18.0005 10.0003C18.0005 10.0825 17.9843 10.1638 17.9529 10.2397C17.9214 10.3156 17.8753 10.3845 17.8172 10.4425Z" fill="white" />
                                    </svg>
                                }
                                sx={{
                                    height: "48px",
                                    width: "200px",
                                    backgroundColor: PRIMARY.P_BLue,
                                    margin: "20px"
                                }}
                            >UNMAPPED_TARGETING
                            </Button>
                            {/* UPLOAD COMPONENT */}
                            <div >
                                <Button
                                    loading={loading === "UPDATE_TARGETING"}
                                    component="label"
                                    role={undefined}
                                    tabIndex={-1}
                                    variant="outlined"
                                    color="neutral"
                                    style={{
                                        height: "48px",

                                        margin: "20px",
                                        border: `1px dashed ${BLACK.B_10}`
                                    }}
                                >
                                    <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                                        <div style={{ display: "flex", alignItems: "center", fontSize: 14, fontWeight: 700, lineHeight: "20px" }} >
                                            Upload Mapped Targeting File Here
                                        </div>
                                    </div>
                                    <VisuallyHiddenInput
                                        onChange={(e) => onFileChange(e, "UPDATE_TARGETING")}
                                        type="file" />
                                </Button>
                            </div>
                        </div>


                        <div style={{ display: "flex", justifyContent: "start", alignItems: "center" }} >
                            <div style={{
                                fontSize: 24,
                                margin: 20
                            }} >
                                Campaign
                            </div>
                            <Button
                                loading={loading === "MASTER_CAMPAIGN"}
                                onClick={() => downloadClickHandler("MASTER_CAMPAIGN")}

                                endDecorator={
                                    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                                        <path d="M17.8172 10.4425L12.1922 16.0675C12.0749 16.1848 11.9159 16.2507 11.75 16.2507C11.5841 16.2507 11.4251 16.1848 11.3078 16.0675C11.1905 15.9503 11.1247 15.7912 11.1247 15.6253C11.1247 15.4595 11.1905 15.3004 11.3078 15.1832L15.8664 10.6253H3.625C3.45924 10.6253 3.30027 10.5595 3.18306 10.4423C3.06585 10.3251 3 10.1661 3 10.0003C3 9.83459 3.06585 9.67562 3.18306 9.55841C3.30027 9.4412 3.45924 9.37535 3.625 9.37535H15.8664L11.3078 4.81753C11.1905 4.70026 11.1247 4.5412 11.1247 4.37535C11.1247 4.2095 11.1905 4.05044 11.3078 3.93316C11.4251 3.81588 11.5841 3.75 11.75 3.75C11.9159 3.75 12.0749 3.81588 12.1922 3.93316L17.8172 9.55816C17.8753 9.61621 17.9214 9.68514 17.9529 9.76101C17.9843 9.83688 18.0005 9.91821 18.0005 10.0003C18.0005 10.0825 17.9843 10.1638 17.9529 10.2397C17.9214 10.3156 17.8753 10.3845 17.8172 10.4425Z" fill="white" />
                                    </svg>
                                }
                                sx={{
                                    height: "48px",
                                    width: "200px",
                                    backgroundColor: PRIMARY.P_BLue,
                                    margin: "20px"
                                }}
                            >MASTER_CAMPAIGN
                            </Button>
                            <Button
                                loading={loading === "UNMAPPED_CAMPAIGN"}
                                onClick={() => downloadClickHandler("UNMAPPED_CAMPAIGN")}

                                endDecorator={
                                    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                                        <path d="M17.8172 10.4425L12.1922 16.0675C12.0749 16.1848 11.9159 16.2507 11.75 16.2507C11.5841 16.2507 11.4251 16.1848 11.3078 16.0675C11.1905 15.9503 11.1247 15.7912 11.1247 15.6253C11.1247 15.4595 11.1905 15.3004 11.3078 15.1832L15.8664 10.6253H3.625C3.45924 10.6253 3.30027 10.5595 3.18306 10.4423C3.06585 10.3251 3 10.1661 3 10.0003C3 9.83459 3.06585 9.67562 3.18306 9.55841C3.30027 9.4412 3.45924 9.37535 3.625 9.37535H15.8664L11.3078 4.81753C11.1905 4.70026 11.1247 4.5412 11.1247 4.37535C11.1247 4.2095 11.1905 4.05044 11.3078 3.93316C11.4251 3.81588 11.5841 3.75 11.75 3.75C11.9159 3.75 12.0749 3.81588 12.1922 3.93316L17.8172 9.55816C17.8753 9.61621 17.9214 9.68514 17.9529 9.76101C17.9843 9.83688 18.0005 9.91821 18.0005 10.0003C18.0005 10.0825 17.9843 10.1638 17.9529 10.2397C17.9214 10.3156 17.8753 10.3845 17.8172 10.4425Z" fill="white" />
                                    </svg>
                                }
                                sx={{
                                    height: "48px",
                                    width: "200px",
                                    backgroundColor: PRIMARY.P_BLue,
                                    margin: "20px"
                                }}
                            >UNMAPPED_CAMPAIGN
                            </Button>
                            {/* UPLOAD COMPONENT */}
                            <div >
                                <Button
                                    loading={loading === "UPDATE_CAMPAIGN"}
                                    component="label"
                                    role={undefined}
                                    tabIndex={-1}
                                    variant="outlined"
                                    color="neutral"
                                    style={{
                                        height: "48px",

                                        margin: "20px",
                                        border: `1px dashed ${BLACK.B_10}`
                                    }}
                                >
                                    <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                                        <div style={{ display: "flex", alignItems: "center", fontSize: 14, fontWeight: 700, lineHeight: "20px" }} >
                                            Upload Mapped Campaign File Here
                                        </div>
                                    </div>
                                    <VisuallyHiddenInput
                                        onChange={(e) => onFileChange(e, "UPDATE_CAMPAIGN")}
                                        type="file" />
                                </Button>
                            </div>
                        </div>


                    </>
                )
            }
        </div>
    )
}


export default Masters